export const GET_STOPS = 'GET_STOPS';
export const GET_STOP_BY_ID = 'GET_STOP_BY_ID';
export const UPDATE_STOP = 'UPDATE_STOP';
export const DELETE_STOP = 'DELETE_STOP';
export const CREATE_STOP = 'CREATE_STOP';
